import { AppLang } from './types';

export const detectInitialLanguage = (): AppLang => {
  if (typeof navigator === 'undefined') {
    return AppLang.en;
  }

  const language = (navigator.languages?.[0] || navigator.language || '').toLowerCase();

  return language.startsWith('ru') ? AppLang.ru : AppLang.en;
};
